import { Component, OnInit, Input, Output , EventEmitter} from '@angular/core';

@Component({
  selector: 'ark-chiplist',
  templateUrl: './chiplist.component.html',
  styleUrls: ['./chiplist.component.scss']
})
export class ChiplistComponent implements OnInit {

  objectKeys = Object.keys;

  @Input() keywords: any;
  @Output() onClick = new EventEmitter<any>();

  constructor() { }

  ngOnInit() {
  }

  removeKeyword(event) {
    this.onClick.emit(event);
  }

}
